/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const conversationTableRowStyle = {
  row: {
    padding: 0,
    cursor: "pointer",
  },
  hiddenColumn: {
    display: {
      xs: "none",
      md: "table-cell",
    },
  },
  iconStack: {
    justifyContent: "center",
    marginTop: "0.2rem",
  },
  subjectColumn: {
    maxWidth: 0,
    width: "100%",
  },
  dateColumn: {
    width: "auto",
    paddingRight: {
      xs: "0.5em",
      md: "1.25rem",
    },
  },
  column: (theme: Theme) => ({
    padding: "1rem 0",
    borderBottom: `1px solid ${theme.palette.divider}`,
    verticalAlign: "top",
  }),
  columnCenter: {
    padding: "1rem",
    paddingLeft: {
      xs: "0rem",
      md: "1rem",
    },
  },
  columnAlert: {
    paddingTop: "0rem",
  },
  icon: {
    marginLeft: "0.25rem",
  },
  textOverflow: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },
  messageButton: (theme: Theme) => ({
    maxWidth: "100%",
    "&:focus-visible": {
      outline: `0.125rem solid ${theme.palette.primary.main}`,
      outlineOffset: "0.125rem",
    },
  }),
  unreadIconContainer: (theme: Theme) => ({
    position: "relative",
    "&::before": {
      content: "''",
      position: "absolute",
      width: "0.75rem",
      aspectRatio: "1/1",
      borderRadius: "50%",
      top: "0rem",
      right: "0rem",
      backgroundColor: theme.palette.warning.main,
      transform: "translateX(0) translateY(-15%)",
    },
  }),
};
